import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '@/app/api/apiSlice'

const sponsorUserPadsAdapter = createEntityAdapter({})

const initialState = sponsorUserPadsAdapter.getInitialState()

export const sponsorUserPadsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getSponsorUserPads: builder.query({
            query: () => ({
                url: '/sponsorUserPads/getSponsorUserPads',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedSponsorUserPads = responseData.map(sponsorUserPad => {
                    sponsorUserPad.id = sponsorUserPad._id
                    return sponsorUserPad
                })
                return sponsorUserPadsAdapter.setAll(initialState, loadedSponsorUserPads)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'SponsorUserPad', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'SponsorUserPad', id}))
                    ]
                } else {
                    return [ { type: 'SponsorUserPad', id: 'LIST'}]
                }
            },
        }),
        createNewSponsorUserPad: builder.mutation({
            query: initialSponsorUserPad => ({
                url: '/sponsorUserPads/createNewSponsorUserPad',
                method: 'POST',
                body: {...initialSponsorUserPad,}
            }),
            invalidatesTags: [
                { type: 'SponsorUserPad', id: "LIST" }
            ] 
        }),
        createNewSponsorUserPadsByOrg: builder.mutation({                       // 05 Aug 2024
            query: initialSponsorUserPadsByOrg => ({
                url: '/sponsorUserPads/createNewSponsorUserPadsByOrg',
                method: 'POST',
                body: {...initialSponsorUserPadsByOrg,}
            }),
            invalidatesTags: [
                { type: 'SponsorUserPadsByOrg', id: "LIST" }
            ] 
        }),
        updateSponsorUserPad: builder.mutation({
            query: initialSponsorUserPad => ({
                url: '/sponsorUserPads/updateSponsorUserPad',
                method: 'PATCH',
                body: {...initialSponsorUserPad,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'SponsorUserPad', id: arg.id },
                { type: 'SponsorUserPad', id: 'LIST' }
            ],
        }),
        deleteSponsorUserPad: builder.mutation({
            query: ({id}) => ({
                url: '/sponsorUserPads/deleteSponsorUserPad',
                method: 'DELETE',
                body: {id}
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'SponsorUserPad', id: arg.id}
            ]
        }),
    }),
})

export const {
    useGetSponsorUserPadsQuery,
    useCreateNewSponsorUserPadMutation,
    useCreateNewSponsorUserPadsByOrgMutation, // 05 Aug 2024
    useUpdateSponsorUserPadMutation,
    useDeleteSponsorUserPadMutation,
} = sponsorUserPadsApiSlice

// returns the query result object
export const selectSponsorUserPadResult = sponsorUserPadsApiSlice.endpoints.getSponsorUserPads.select()

// create memoized selector
const selectSponsorUserPadsData = createSelector(
    selectSponsorUserPadResult,
    sponsorUserPadResult => sponsorUserPadResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllSponsorUserPads,
    selectById: selectSponsorUserPadById,
    selectIds: selectSponsorUserPadIds,
} = sponsorUserPadsAdapter.getSelectors(state => selectSponsorUserPadsData(state) ?? initialState)